import { render, staticRenderFns } from "./tfoot.vue?vue&type=template&id=67dfc6eb&"
import script from "./tfoot.vue?vue&type=script&lang=js&"
export * from "./tfoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports